export default "__VITE_ASSET__hyePelri__"